/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { greaterThan, minNumber, requiredNumber, ValidatorSchema } from '@irian-ro/util-forms';
import { PackageDtoModel } from '../package-dto.model';

export const packageDtoValidators = (): ValidatorSchema<PackageDtoModel> => {
  return {
    height: [requiredNumber, minNumber(1)],
    width: [requiredNumber, minNumber(1)],
    length: [requiredNumber, minNumber(1)],
    weight: [requiredNumber, greaterThan(0)],
    pieces: [requiredNumber, minNumber(1)],
  };
};
